<template>

    <Modal
      ref="appInfoModal"
      :title="'App Info'"
      :width="'420px'"
    >
      <template #modal-main>
        <div class="info-modal-body">
          This is an internally triggered app. The card is for information purpose only.
        </div>
      </template>
      <template #modal-footer>
        <div class="info-modal-footer">
          <button class="info-modal-button" @click="closeInfoModal">OK</button>
        </div>
      </template>
    </Modal>


    <div class="app-card" >
        <div class="head">
            <h3>{{ params.title }}</h3>
            <div class="app-type">{{ params.type }}</div>
        </div>

        
        <img class="app-image" :src="imageURL" alt="Project Image"/>
        
        <div class="body__grid">

            <div
              v-tooltip:top="params.description"
              class="description-value"
            >
              {{ params.description }}
            </div>

            <div class="body__grid-spacer"></div>

            <hr>

            <div class="info-row">
              <div class="info-row__lines">
                <div class="info-line info-line--with-runs">
                  <span>{{ params.name }} : {{ params.version }}</span>
                  <span v-tooltip:top="`Runs : ${params.runs}`" class="runs-display">
                    <v-icon class="runs-icon" size="16">mdi-play</v-icon>
                    <span class="runs-value">{{ params.runs }}</span>
                  </span>
                </div>
                <div class="info-line">{{ params.author }}</div>
              </div>
            </div>
        </div>
        
        <div class="footer">
          <a
            v-if="params.docs"
            v-tooltip:top="params.docs"
            class="help-button"
            :href="params.docs"
            target="_blank"
            rel="noopener"
          >
            Help
          </a>

          <div v-if="params.price>0" class="price">${{ params.price }} / hour</div>
          <div v-else class="price">Free</div>

          <button
            v-if="params.user_launchable"
            v-tooltip="`Execute this app`"
            class="run-app-button"
            @click="startApp(params.name)"
          >
            Run App
          </button>
        </div>
       
    </div>
    
</template>

<script setup>
import {ref, defineEmits,defineProps,computed } from 'vue';
import IconButton from '@/components/IconButton.vue';
import Modal from '@/components/Modal.vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import SVGIcon from '@/components/SVGIcon.vue';
import testImage from '@/assets/img/test.png';

const $toast = useToast();
const dataConnect = new DatastoreConnect();
const emit = defineEmits(['app_selected']);


const props = defineProps({
  params: {
    type: Object,
    required: true,
  },
});

const appInfoModal = ref(null);
const loading = ref(false);

function startApp(code) {
    emit('app_selected',code);
}

function showInfoModal() {
  appInfoModal.value?.showModal();
}

function closeInfoModal() {
  appInfoModal.value?.closeModal();
}


function formatTime(str) {
  return `${new Date(str).toLocaleTimeString('default', {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true,
  })}`;
}

const imageURL = computed(() => {
    let url=`/resource/image?type=app&id=${props.params.id}`
    return url;

});

const icon_name = computed(() => {
  if (props.params.type=='import') return "mdi-import";
  if (props.params.type=='export') return "mdi-export";
  if (props.params.type=='train') return "mdi-chip";
  if (props.params.type=='test') return testImage;
  if (props.params.type=='data') return "mdi-database";

  return "mdi-check-bold";
});

</script>

<style lang="scss" scoped>
.app-card {
  min-width: 300px;
  max-width: 300px;
  height: 400px;
  display: flex;
  flex-direction: column;
  position: relative;
  text-align: left;
  overflow: hidden;
  border-radius: 8px;
  margin: 0;
  border: 1px solid rgb(193, 193, 193);

  box-shadow: 2px 2px 6px 6px rgba(162, 162, 162, 0.2), 0 0 1px 1px rgba(0, 0, 0, 0.05);
}

.head {
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin: 4px 0px 0px 10px;
}

.app-image {
  height: 130px;
  width: 100%;
  margin-top: 12px;
  overflow: hidden;
  object-fit: contain;
}

.icons {
    display: none;
}

.app-type {
    font-size: 0.65rem;
    color: #666;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.footer {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background: #e7e7e8;
  padding: 6px 8px;
  border-radius: 0px;
  position: relative;
}



.run-app-button {
  height: 26px;
  padding: 0 12px;
  background: #3573b2;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transition: background 0.15s ease;
}

.run-app-button:hover {
  background: #1c3a68;
}

.runs-display {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.7rem;
  font-weight: 400;
  color: var(--body-text-color);
}

.runs-label {
  color: var(--body-text-color-secondary);
}

.runs-value {
  color: var(--body-text-color);
}

.type-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.price {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  border: 1px solid rgb(99, 114, 142);
  border-radius: 6px;
  padding: 0 8px;
  color: rgb(12, 59, 99);
  font-style: italic;
  text-align: center;
  line-height: 1;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.info-modal-body {
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  line-height: 1.5;
  text-align: left;
}

.info-modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 0.75rem 1.5rem 1.25rem;
}

.info-modal-button {
  padding: 8px 18px;
  border: 1px solid rgb(99, 114, 142);
  border-radius: 6px;
  background: white;
  color: rgb(12, 59, 99);
  cursor: pointer;
}

.description-value {
  display: -webkit-box !important;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: normal !important;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
  word-break: break-word;
  width: 100%;
  min-width: 0;
  font-style: italic;
  font-size: 0.8rem;
  color: rgb(12, 59, 99);
  padding: 4px 0;
}

.body__grid {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

.body__grid-spacer {
  flex: 1 1 auto;
  min-height: 8px;
}

.info-line {
  font-size: 0.8rem;
  color: var(--body-text-color);
  padding: 1px 0;
}

.info-line--with-runs {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.runs-icon {
  color: var(--body-text-color-secondary);
  cursor: default;
}

.info-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

}

.info-row__lines {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1 auto;
}

.help-button {
  align-self: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  padding: 0 14px;
  background: #2e7d32;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  border-radius: 6px;
  text-decoration: none;
  white-space: nowrap;
  line-height: 1;
  transition: background 0.15s ease;
}

.help-button:hover {
  background: #1b5e20;
  color: #fff;
}

.info-line--link {
  color: rgb(12, 59, 99);
  text-decoration: underline;
  word-break: break-all;
}
</style>